import Blog from './blog';
// import ReactDOM from '../../node_modules/ReactDOM';

(function(window, document, undefined){
    window.onload = init;

    function init(){ 
        const blogId = document.getElementById("blog-app");
        // console.log(blogId);
        if (blogId) {
            const cats = blogId ? blogId.dataset.cats : null;
            const recipeMonth = blogId ? blogId.dataset.recipeMonth : null;
            const subscribe = blogId ? blogId.dataset.sub : null;
            const video = blogId ? blogId.dataset.video : null;
            const loading = blogId ? blogId.dataset.loading : null;

            ReactDOM.render( <Blog
                cats={ JSON.parse(cats) }
                subscribe={ JSON.parse(subscribe) }
                video={ JSON.parse(video) }
                loading={ JSON.parse(loading) }
                recipeMonth={ JSON.parse(recipeMonth) }  />, blogId); 
        }
    }

})(window, document, undefined);